export enum SubOrderType {
  FullServe = 'FULL_SERVE_ORDER',
}
